"use client"

import Navbar from '@/Components/DoctorsDashboard/AdminDashboard/Navbar';
import Header from '@/Components/website/common/Header/Header';
import { usePathname } from 'next/navigation';
import React from 'react'
import { useSelector } from 'react-redux';

const ShouldDisplay = () => {

	const publicRoutes = [
		"/about-us",
		"/contact-us",
		"/privacy-and-security",
		"/terms-and-conditions",
		"/privacy-policy",
		"/reps",
		"/products",
		"/search/query"
	]
	const users = useSelector((state) => state?.userData?.userData?.user);
	function determineDisplay(pathname, user) {
		// Every route in this (public) group needs the same treatment: the
		// marketing Header when signed out, the dashboard Navbar when signed in.
		// /pipeline and the non-query /search routes were in neither list, so
		// they fell through to the default and rendered the dashboard Navbar to
		// signed-out visitors — which shows nothing without a user.
		const isSpecialRoute =
			pathname.startsWith("/products") ||
			pathname.startsWith("/search") ||
			pathname.startsWith("/pipeline");
		const isAllowedRoute = publicRoutes.some(route => {
			return pathname.startsWith(route)
		});
		
		if (pathname === "/") {
			return <Header />
		} 
		// Check for special route with user types
		else if (isSpecialRoute && user) {
			// Both reps and providers should see dashboard layout for search results
			return <Navbar show={false} />;
		}
		// Handle case when no user but special route
		else if (!user && isSpecialRoute) {
			return <Header />;
		}
		// Handle allowed routes
		else if (isAllowedRoute) {
			return <Header show={false} />;
		}
		// Default case
		else {
			return <Navbar show={false} />;
		}
	}

	const pathname = usePathname();

	return (
		<>
			{determineDisplay(pathname, users)}
		</>
	)
}

export default ShouldDisplay